import { render } from "./ButtonGradient.vue?vue&type=template&id=3df49ed9&scoped=true"
import script from "./ButtonGradient.vue?vue&type=script&lang=js"
export * from "./ButtonGradient.vue?vue&type=script&lang=js"

import "./ButtonGradient.vue?vue&type=style&index=0&id=3df49ed9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df49ed9"]])

export default __exports__